import { render, staticRenderFns } from "./CookiesSnackBar.vue?vue&type=template&id=04362dcf"
import script from "./CookiesSnackBar.vue?vue&type=script&lang=js"
export * from "./CookiesSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports